import { breakpoint } from '@zocdoc/components/src/grid/index';
import { FontFamily } from '@zocdoc/components/src/typography/index';
import { FormattedMessage } from 'react-intl';
import * as Layout from '@zocdoc/components/src/Layout/index';
import { navy } from '@zocdoc/branding/colors/index';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { HOMEPAGE_HEADER_V2 } from '../../../config/ab/experiments';
import { isVariantA, isVariantB } from '../../experiments/headlineV2';
import { LOCALIZED_STRINGS } from '../../constants';
import withAB from '../../../config/ab/withAB';

class HeadlinePanel extends PureComponent {
    static propTypes = {
        ab: PropTypes.shape({
            experimentId: PropTypes.string,
            defaultAssignment: PropTypes.string,
            isFeatureFlag: PropTypes.bool,
        }),
    };

    static defaultProps = {
        ab: { [HOMEPAGE_HEADER_V2.experimentId]: HOMEPAGE_HEADER_V2.defaultAssignment },
    };

    render() {
        let headlineFirstPart;
        let headlineSecondPart;
        let headlineThirdPart;

        if (isVariantA(this.props)) {
            headlineFirstPart = LOCALIZED_STRINGS.FEELING_MEH_FREE_LINE_1;
            headlineSecondPart = LOCALIZED_STRINGS.FEELING_MEH_FREE_LINE_2;
            headlineThirdPart = LOCALIZED_STRINGS.FEELING_MEH_FREE_LINE_3;
        } else if (isVariantB(this.props)) {
            headlineFirstPart = LOCALIZED_STRINGS.RIGHT_DOCTOR_RIGHT_NOW_LINE_1;
            headlineSecondPart = LOCALIZED_STRINGS.RIGHT_DOCTOR_RIGHT_NOW_LINE_2;
        } else {
            headlineFirstPart = LOCALIZED_STRINGS.FEELING_MEH_LINE_1;
            headlineSecondPart = LOCALIZED_STRINGS.FEELING_MEH_LINE_2;
        }

        if (isVariantA(this.props)) {
            return (
                <HeadlineArea>
                    <HeadlineABVariants>
                        {this.maybeRenderHeadlineText(headlineFirstPart)}
                        {this.maybeRenderHeadlineText(headlineSecondPart)}
                        {this.maybeRenderHeadlineText(headlineThirdPart)}
                    </HeadlineABVariants>
                </HeadlineArea>
            );
        } else {
            return (
                <HeadlineArea>
                    <Headline>
                        {this.maybeRenderHeadlineText(headlineFirstPart)}
                        {this.maybeRenderHeadlineText(headlineSecondPart)}
                        {this.maybeRenderHeadlineText(headlineThirdPart)}
                    </Headline>
                </HeadlineArea>
            );
        }
    }

    maybeRenderHeadlineText = headline => {
        if (headline) {
            return (
                <HeadlineText>
                    <FormattedMessage {...headline} />
                </HeadlineText>
            );
        }
    }
}

const HeadlineABVariants = styled.h1`
    color: ${navy};
    font: 32px/36px ${FontFamily.SharpSansBold};

    ${breakpoint.xsmall} {
       font: 40px/1.2 ${FontFamily.SharpSansBold};
    }

    ${breakpoint.medium} {
        font-size: 56px;
    }
    
    ${breakpoint.large} {
        font-size: 72px;
    }
`;
const Headline = styled.h1`
    color: ${navy};
    font: 32px/36px ${FontFamily.SharpSansBold};

    ${breakpoint.xsmall} {
       font: 40px/1.2 ${FontFamily.SharpSansBold};
    }

    ${breakpoint.medium} {
        font-size: 72px;
    }

    ${breakpoint.large} {
        font-size: 80px;
    }
`;

const HeadlineArea = styled(Layout.PaddedContainer)`
    margin: 24px 0 20px;

    ${breakpoint.xsmall} {
        margin: 48px 0 40px;
    }

    ${breakpoint.small} {
        margin: auto;
        margin-bottom: 30px;
        text-align: center;
    }

    ${breakpoint.medium} {
        margin-top: 100px;
        margin-bottom: 65px;
    }
`;

const HeadlineText = styled.div`
    ${breakpoint.small} {
        display: inline-block;

        &:not(:last-child)::after {
            content: '\00a0'; // nbsp in unicode
        }
    }
`;

export default withAB(HOMEPAGE_HEADER_V2)(HeadlinePanel);
